import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuickdonateCardComponent } from './quickdonate-card.component';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';



@NgModule({
  declarations: [
    QuickdonateCardComponent
  ],
  exports: [
    QuickdonateCardComponent
  ],
  imports: [
    CommonModule,
    ModuleLoaderModule
  ]
})
export class QuickdonateCardModule { }
